import { useMutation } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { type ExpenseItemUpdatePayload } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository/ExpenseRepository'

export const useMutateEditExpenseLineItem = () => {
  const mutation = useMutation<void, RepoError, ExpenseItemUpdatePayload>({
    mutationFn: (payload) => expenseRepository.updateItem(payload.id, payload),
  })

  return {
    mutate: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}
